import { render, staticRenderFns } from "./virtualOrders.vue?vue&type=template&id=57839c18&scoped=true&"
import script from "./virtualOrders.vue?vue&type=script&lang=js&"
export * from "./virtualOrders.vue?vue&type=script&lang=js&"
import style0 from "./virtualOrders.vue?vue&type=style&index=0&id=57839c18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57839c18",
  null
  
)

export default component.exports